import { useState, useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';

const API = (process.env.REACT_APP_API_URL||'/api').replace(/\/$/,'');

const css = `
* { box-sizing:border-box; margin:0; padding:0; }
body { font-family:Arial,sans-serif; background:#f0f4f8; min-height:100vh; }
.portal-wrap { max-width:680px; margin:0 auto; padding:16px; }
.portal-hdr  { background:#1a3a5c; border-radius:12px 12px 0 0; padding:16px 20px; display:flex; align-items:center; gap:12px; }
.portal-logo { font-size:28px; }
.portal-ttl  { font-size:14px; font-weight:700; color:#fff; }
.portal-sub  { font-size:11px; color:rgba(255,255,255,.7); margin-top:2px; }
.portal-body { background:#fff; border:1px solid #dde3ec; border-top:none; border-radius:0 0 12px 12px; overflow:hidden; }
.pin-section { padding:24px 20px; text-align:center; }
.pin-title   { font-size:16px; font-weight:700; color:#1a3a5c; margin-bottom:6px; }
.pin-sub     { font-size:12px; color:#6b7a8d; margin-bottom:20px; line-height:1.6; }
.pin-inputs  { display:flex; gap:10px; justify-content:center; margin-bottom:16px; }
.pin-inp     { width:52px; height:60px; border:2px solid #dde3ec; border-radius:10px; text-align:center; font-size:24px; font-weight:700; color:#1a3a5c; outline:none; transition:border-color .15s; }
.pin-inp:focus { border-color:#2e6da4; background:#e6f1fb; }
.pin-err     { background:#fdeaea; border:1px solid #b03030; color:#b03030; border-radius:8px; padding:8px 14px; font-size:12px; margin-bottom:12px; }
.pin-btn     { width:100%; padding:12px; border:none; border-radius:9px; background:#1a3a5c; color:#fff; font-size:13px; font-weight:700; cursor:pointer; transition:background .15s; }
.pin-btn:hover { background:#2e6da4; }
.pin-btn:disabled { opacity:.5; cursor:not-allowed; }
.pac-bar     { background:#1a3a5c; padding:12px 18px; display:flex; gap:12px; align-items:center; }
.pac-av      { width:36px; height:36px; border-radius:50%; background:#2e6da4; display:flex; align-items:center; justify-content:center; font-size:14px; font-weight:700; color:#fff; flex-shrink:0; }
.pac-nom     { font-size:13px; font-weight:700; color:#fff; }
.pac-sub     { font-size:10px; color:rgba(255,255,255,.6); margin-top:2px; }
.res-section { padding:16px 18px; }
.res-grp     { margin-bottom:16px; border:1px solid #dde3ec; border-radius:9px; overflow:hidden; }
.res-grp-hdr { background:#1a3a5c; padding:7px 12px; font-size:10px; font-weight:700; color:#fff; text-transform:uppercase; letter-spacing:.5px; }
.res-table   { width:100%; border-collapse:collapse; }
.res-table th { background:#f0f4f8; padding:5px 10px; font-size:9px; font-weight:700; color:#4a5568; text-transform:uppercase; letter-spacing:.3px; text-align:left; border-bottom:1px solid #dde3ec; }
.res-table td { padding:7px 10px; font-size:12px; border-bottom:1px solid #f0f4f8; vertical-align:middle; }
.res-table tr:last-child td { border-bottom:none; }
.res-table tr.alterado td  { background:#fdeaea; }
.res-val-hi  { color:#b03030; font-weight:700; }
.res-val-lo  { color:#b85c00; font-weight:700; }
.res-val-ok  { color:#1a7a4a; font-weight:600; }
.arrow-hi    { color:#b03030; font-size:14px; font-weight:700; }
.arrow-lo    { color:#b85c00; font-size:14px; font-weight:700; }
.badge-hi    { background:#fdeaea; color:#b03030; font-size:9px; padding:1px 7px; border-radius:4px; font-weight:700; }
.badge-lo    { background:#fff3e0; color:#b85c00; font-size:9px; padding:1px 7px; border-radius:4px; font-weight:700; }
.badge-ok    { background:#e6f5ed; color:#1a7a4a; font-size:9px; padding:1px 7px; border-radius:4px; font-weight:600; }
.obs-box     { background:#e6f1fb; border:1px solid #c8d3e0; border-radius:8px; padding:10px 14px; font-size:11px; color:#1a3a5c; margin-bottom:12px; }
.firma-sec   { background:#f8fafc; border-top:1px solid #dde3ec; padding:14px 18px; display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
.firma-box   { text-align:center; }
.firma-line  { border-top:1px solid #1a3a5c; padding-top:5px; margin-top:24px; }
.firma-nom   { font-size:11px; font-weight:700; color:#1a3a5c; }
.firma-cargo { font-size:10px; color:#6b7a8d; }
.seguro-badge { display:flex; align-items:center; gap:6px; background:#e6f5ed; border:1px solid #1a7a4a; border-radius:8px; padding:8px 12px; font-size:10px; color:#1a7a4a; }
.lopdp-note  { text-align:center; font-size:9px; color:#6b7a8d; padding:10px 18px; border-top:1px solid #f0f4f8; }
@media (max-width:480px) {
  .portal-wrap { padding:0; }
  .portal-hdr  { border-radius:0; }
  .portal-body { border-radius:0; border-left:none; border-right:none; }
  .pin-inp     { width:44px; height:52px; font-size:20px; }
}
`;

const fmtD = s => { if(!s)return'—'; const p=String(s).slice(0,10); const[y,m,d]=p.split('-'); return `${d}/${m}/${y}`; };
const calcEdad = fn => fn ? Math.floor((Date.now()-new Date(fn))/3.156e10)+' años' : '';

export default function ResultadosPortal() {
  const { token } = useParams();
  const [fase,      setFase]    = useState('verificando'); // verificando|pin|resultados|error
  const [nombrePrev,setNombrePrev] = useState('');
  const [pin,       setPin]     = useState(['','','','']);
  const [error,     setError]   = useState('');
  const [loading,   setLoading] = useState(false);
  const [datos,     setDatos]   = useState(null);

  useEffect(()=>{
    verificarToken();
  },[token]);

  const verificarToken = async () => {
    try {
      const r = await fetch(`${API}/laboratorio/portal/${token}`);
      const d = await r.json();
      if (!r.ok) { setFase('error'); setError(d.error||'Enlace no válido'); return; }
      setNombrePrev(d.nombre);
      setFase('pin');
    } catch(_) { setFase('error'); setError('Error de conexión'); }
  };

  const onPinChange = (idx, val) => {
    if (!/^\d*$/.test(val)) return;
    const np = [...pin];
    np[idx] = val.slice(-1);
    setPin(np);
    if (val && idx < 3) document.getElementById(`pin-${idx+1}`)?.focus();
    if (idx === 3 && val) {
      setTimeout(() => document.getElementById('pin-btn')?.click(), 100);
    }
  };

  const onPinKey = (idx, e) => {
    if (e.key === 'Backspace' && !pin[idx] && idx > 0) {
      document.getElementById(`pin-${idx-1}`)?.focus();
    }
  };

  const verificarPin = async () => {
    const pinStr = pin.join('');
    if (pinStr.length < 4) { setError('Ingresa los 4 dígitos'); return; }
    setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/laboratorio/portal/${token}/acceder`, {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ pin: pinStr })
      });
      const d = await r.json();
      if (!r.ok) { setError(d.error||'PIN incorrecto'); setPin(['','','','']); document.getElementById('pin-0')?.focus(); }
      else { setDatos(d); setFase('resultados'); }
    } catch(_) { setError('Error de conexión'); }
    setLoading(false);
  };

  const evalRango = (val, li, ls) => {
    if (!val || val==='') return 'na';
    const v = parseFloat(val);
    if (isNaN(v)) return 'na';
    if (ls > 0 && v > ls) return 'hi';
    if (li > 0 && v < li) return 'lo';
    return 'ok';
  };

  const agruparDetalles = detalles => {
    const grupos = {};
    detalles.forEach(d => {
      const k = d.COD_TIPO_DETERMINACION;
      if (!grupos[k]) grupos[k] = { nombre: d.TIPO_DETERMINACION, items: [] };
      grupos[k].items.push(d);
    });
    return Object.values(grupos);
  };

  return (
    <>
      <style>{css}</style>
      <div className="portal-wrap">

        {/* Header */}
        <div className="portal-hdr">
          <span className="portal-logo">🔬</span>
          <div>
            <div className="portal-ttl">{datos?.establecimiento?.NOMBRE_ESTABLECIMIENTO || 'Laboratorio Clínico'}</div>
            <div className="portal-sub">Portal de resultados · Acceso seguro</div>
          </div>
        </div>

        <div className="portal-body">

          {/* Verificando */}
          {fase==='verificando'&&(
            <div className="pin-section">
              <div style={{fontSize:24,marginBottom:12}}>⏳</div>
              <div className="pin-title">Verificando enlace...</div>
            </div>
          )}

          {/* PIN */}
          {fase==='pin'&&(
            <div className="pin-section">
              <div style={{fontSize:32,marginBottom:10}}>🔒</div>
              <div className="pin-title">Acceso a resultados de laboratorio</div>
              <div className="pin-sub">
                Hola <strong>{nombrePrev}</strong>, para proteger tu información ingresa<br/>
                los <strong>últimos 4 dígitos de tu cédula</strong>
              </div>
              {error&&<div className="pin-err">⚠️ {error}</div>}
              <div className="pin-inputs">
                {[0,1,2,3].map(i=>(
                  <input key={i} id={`pin-${i}`} className="pin-inp" type="tel"
                    maxLength={1} value={pin[i]} autoFocus={i===0}
                    onChange={e=>onPinChange(i,e.target.value)}
                    onKeyDown={e=>onPinKey(i,e)}/>
                ))}
              </div>
              <button id="pin-btn" className="pin-btn" disabled={loading||pin.join('').length<4} onClick={verificarPin}>
                {loading?'Verificando...':'🔓 Acceder a mis resultados'}
              </button>
              <div style={{marginTop:12,fontSize:10,color:'#6b7a8d'}}>
                🛡️ Acceso protegido — máximo 3 intentos
              </div>
            </div>
          )}

          {/* Error */}
          {fase==='error'&&(
            <div className="pin-section">
              <div style={{fontSize:32,marginBottom:10}}>❌</div>
              <div className="pin-title" style={{color:'#b03030'}}>Enlace no disponible</div>
              <div className="pin-sub">{error}</div>
              <div style={{marginTop:16,fontSize:11,color:'#6b7a8d'}}>
                Contacta al laboratorio para obtener un nuevo enlace.
              </div>
            </div>
          )}

          {/* Resultados */}
          {fase==='resultados'&&datos&&(()=>{
            const { paciente, examen, detalles, establecimiento } = datos;
            const grupos = agruparDetalles(detalles);
            const edad   = calcEdad(paciente.nacimiento);
            const sexo   = paciente.sexo==='M'?'Masculino':paciente.sexo==='F'?'Femenino':'—';
            const iniciales = (paciente.nombre?.split(' ')||[]).slice(0,2).map(n=>n[0]).join('');

            return (
              <>
                {/* Datos paciente */}
                <div className="pac-bar">
                  <div className="pac-av">{iniciales}</div>
                  <div>
                    <div className="pac-nom">{paciente.nombre}</div>
                    <div className="pac-sub">CI: {paciente.cedula} · {edad} · {sexo}</div>
                  </div>
                  <div style={{marginLeft:'auto',textAlign:'right'}}>
                    <div style={{fontSize:10,color:'rgba(255,255,255,.6)'}}>Fecha solicitud</div>
                    <div style={{fontSize:11,color:'#fff',fontWeight:600}}>{fmtD(examen.fecha_solicitud)}</div>
                  </div>
                </div>

                <div className="res-section">
                  {/* Observaciones */}
                  {examen.obs_resultados&&(
                    <div className="obs-box">
                      <strong>Observaciones:</strong> {examen.obs_resultados}
                    </div>
                  )}

                  {/* Grupos de resultados */}
                  {grupos.map((g,gi)=>(
                    <div key={gi} className="res-grp">
                      <div className="res-grp-hdr">{g.nombre}</div>
                      <table className="res-table">
                        <thead>
                          <tr>
                            <th style={{width:'35%'}}>Examen</th>
                            <th style={{width:'15%'}}>Resultado</th>
                            <th style={{width:'12%'}}>Unidad</th>
                            <th style={{width:'20%'}}>V. Referencia</th>
                            <th style={{width:'18%'}}>Estado</th>
                          </tr>
                        </thead>
                        <tbody>
                          {g.items.map((item,ii)=>{
                            const est = evalRango(item.RESULTADO, item.LIMITE_INFERIOR, item.LIMITE_SUPERIOR);
                            return (
                              <Fragment key={ii}>
                              <tr className={est!=='ok'&&est!=='na'?'alterado':''}>
                                <td>{item.DETERMINACION}</td>
                                <td className={`res-val-${est==='na'?'ok':est}`}>
                                  {est==='hi'&&<span className="arrow-hi">↑ </span>}
                                  {est==='lo'&&<span className="arrow-lo">↓ </span>}
                                  {item.RESULTADO||'—'}
                                </td>
                                <td style={{fontSize:10,color:'#6b7a8d'}}>{item.UNIDAD||'—'}</td>
                                <td style={{fontSize:10,color:'#6b7a8d'}}>
                                  {item.LIMITE_INFERIOR>0||item.LIMITE_SUPERIOR>0
                                    ?`${item.LIMITE_INFERIOR>0?item.LIMITE_INFERIOR:''} – ${item.LIMITE_SUPERIOR>0?item.LIMITE_SUPERIOR:''}`
                                    :item.OBS_RANGO?item.OBS_RANGO.split('\n')[0]:'—'}
                                </td>
                                <td>
                                  {est==='ok'&&<span className="badge-ok">Normal</span>}
                                  {est==='hi'&&<span className="badge-hi">↑ Alto</span>}
                                  {est==='lo'&&<span className="badge-lo">↓ Bajo</span>}
                                  {est==='na'&&<span style={{fontSize:10,color:'#6b7a8d'}}>—</span>}
                                </td>
                              </tr>
                              {(item.subdeterminaciones||[]).map((sub,si)=>{
                                const estSub = evalRango(sub.resultado, sub.limite_inf, sub.limite_sup);
                                return (
                                  <tr key={`${ii}-${si}`} className={estSub!=='ok'&&estSub!=='na'?'alterado':''}>
                                    <td style={{paddingLeft:20,fontSize:12,color:'#4a5568'}}>{sub.nombre}</td>
                                    <td className={`res-val-${estSub==='na'?'ok':estSub}`}>
                                      {estSub==='hi'&&<span className="arrow-hi">↑ </span>}
                                      {estSub==='lo'&&<span className="arrow-lo">↓ </span>}
                                      {sub.resultado||'—'}
                                    </td>
                                    <td style={{fontSize:10,color:'#6b7a8d'}}>{sub.unidad||'—'}</td>
                                    <td style={{fontSize:10,color:'#6b7a8d'}}>
                                      {sub.limite_inf>0||sub.limite_sup>0
                                        ?`${sub.limite_inf>0?sub.limite_inf:''} – ${sub.limite_sup>0?sub.limite_sup:''}`
                                        :'—'}
                                    </td>
                                    <td>
                                      {estSub==='ok'&&<span className="badge-ok">Normal</span>}
                                      {estSub==='hi'&&<span className="badge-hi">↑ Alto</span>}
                                      {estSub==='lo'&&<span className="badge-lo">↓ Bajo</span>}
                                      {estSub==='na'&&<span style={{fontSize:10,color:'#6b7a8d'}}>—</span>}
                                    </td>
                                  </tr>
                                );
                              })}
                              </Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ))}

                  {/* Firma */}
                  <div className="firma-sec">
                    <div className="seguro-badge">
                      🛡️ Resultados validados · {fmtD(examen.fecha_validacion)}
                    </div>
                    {examen.laboratorista&&(
                      <div className="firma-box">
                        <div className="firma-line">
                          <div className="firma-nom">{examen.laboratorista}</div>
                          <div className="firma-cargo">Laboratorista responsable</div>
                          {establecimiento.REGISTRO_MSP_DIR&&<div className="firma-cargo">Reg. MSP: {establecimiento.REGISTRO_MSP_DIR}</div>}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="lopdp-note">
                    🔒 Sus datos están protegidos conforme a la Ley Orgánica de Protección de Datos Personales (LOPDP) · Ecuador<br/>
                    {establecimiento.NOMBRE_ESTABLECIMIENTO} · {establecimiento.TELEFONO_EMPRESA||''} · {establecimiento.DIRECCION||''}
                  </div>
                </div>
              </>
            );
          })()}

        </div>
      </div>
    </>
  );
}
